/**
 * Frontend mirror of the canonical role → permission catalog
 * (datasets/roles_permissions.json / functions ROLE_CATALOG). Used only to
 * *simulate* another role's view in the "View as" preview — the server always
 * re-checks the real permissions, so this map never grants anything. Keep it in
 * sync with the source of truth; a stale entry only mis-renders a preview.
 */

export const ROLE_PERMISSIONS: Record<string, string[]> = {
  super_admin: ["*"],
  developer: ["*", "system.maintenance"],
  candidate: ["projects.view", "crm.view", "field.contact", "finance.view", "aura.query", "aura.canonical.approve", "strategy.view", "briefing.view", "calltime.use", "rapidresponse.practice", "media.scout"],
  campaign_manager: ["projects.view", "projects.manage", "tasks.manage", "crm.view", "crm.manage", "field.manage", "voters.view", "field.contact", "events.manage", "aura.query", "hermes.run", "hermes.review", "strategy.view", "briefing.view", "rapidresponse.practice", "rapidresponse.manage", "media.scout"],
  chief_strategist: ["projects.view", "crm.view", "evidence.ingest", "evidence.restricted.view", "aura.query", "aura.canonical.approve", "hermes.run", "hermes.review", "strategy.view", "briefing.view", "rapidresponse.practice", "media.scout"],
  operations_owner: ["admin.users.manage", "admin.roles.manage", "projects.view", "projects.manage", "tasks.manage", "crm.view", "crm.manage", "crm.export", "field.manage", "voters.view", "voters.import", "field.contact", "events.manage", "communications.publish", "finance.view", "finance.manage", "finance.approve", "compliance.review", "evidence.ingest", "evidence.restricted.view", "aura.query", "aura.canonical.approve", "audit.view", "security.sessions.revoke", "hermes.run", "hermes.review", "strategy.view", "briefing.view", "calltime.use", "calltime.manage", "rapidresponse.practice", "media.scout"],
  treasurer: ["finance.view", "finance.manage", "finance.approve", "compliance.review", "audit.view", "calltime.use", "calltime.manage"],
  legal_counsel: ["finance.view", "compliance.review", "evidence.restricted.view", "audit.view"],
  field_director: ["projects.view", "tasks.manage", "crm.view", "crm.manage", "field.manage", "voters.view", "voters.import", "field.contact", "events.manage"],
  communications_director: ["projects.view", "crm.view", "communications.publish", "evidence.ingest", "aura.query", "hermes.run", "rapidresponse.practice", "media.scout"],
  researcher: ["projects.view", "evidence.ingest", "aura.query", "hermes.run"],
  volunteer: ["projects.view", "field.contact"],
};

/** Roles an unrestricted account can preview, in a sensible display order. */
export const PREVIEWABLE_ROLES = [
  "operations_owner",
  "candidate",
  "campaign_manager",
  "chief_strategist",
  "treasurer",
  "legal_counsel",
  "field_director",
  "communications_director",
  "researcher",
  "volunteer",
] as const;

export function permissionsForRole(role: string): string[] {
  return ROLE_PERMISSIONS[role] ?? [];
}
